<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown
    v-if="notifications"
    vs-custom-content
    vs-trigger-click
    class="cursor-pointer"
  >
    <feather-icon
      :icon="['fal', 'bell']"
      class="cursor-pointer notification-icon"
      :badge="notifications.unread"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notifications.unread }} neue</h3>
        <p class="opacity-75">
          Benachrichtigungen
        </p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        :key="$vs.rtl"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in notifications.results"
            :key="ntf.index"
            class="px-4 py-4 notification cursor-pointer"
          >
            <div class="flex items-start">
              <feather-icon
                v-if="ntf.icon"
                :icon="ntf.icon"
                :svg-classes="[
                  `text-${ntf.category}`,
                  'stroke-current mr-1 h-6 w-6'
                ]"
              />
              <div>
                <span
                  class="font-medium block notification-title"
                  :class="[`text-${ntf.category}`]"
                  @click="markRead(ntf.id, ntf.data)"
                  >{{ ntf.title }}</span
                >
                <small @click="markRead(ntf.id, ntf.data)">{{
                  ntf.message
                }}</small>
                <small
                  v-if="ntf.category == 'RESUBMISSION'"
                  @click="
                    $router.push({
                      name: 'applicant.edit.sub',
                      params: { page: 'resubmission', id: ntf.data['ref_id'] }
                    })
                  "
                >
                  Ansehen
                </small>
              </div>
            </div>
            <div class="flex justify-between mt-1">
              <small class="flex-grow mt-1 whitespace-no-wrap">{{
                elapsedTime(ntf.createdAt)
              }}</small>
              <span
                class="flex-shrink px-2"
                @click="markRead(ntf.id, ntf.data)"
              >
                <feather-icon v-if="!ntf.readAt" :icon="['far', 'eye']" />
                <feather-icon v-else :icon="['far', 'eye-slash']" />
              </span>
              <span class="flex-shrink px-2" @click="deleteNtf(ntf.id)">
                <feather-icon :icon="['far', 'trash']" />
              </span>
            </div>
          </li>
        </ul>
      </component>

      <!--
      <div
        class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer"
      >
        <span>View All Notifications</span>
      </div>
      -->
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import gql from "graphql-tag";

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      currentPage: 1
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  apollo: {
    notifications: {
      query: gql`
        query Notifications($page: Int!, $onlyNew: Boolean) {
          notifications(page: $page, onlyNew: $onlyNew) {
            total
            unread
            results {
              id
              type
              title
              message
              data
              createdAt
              readAt
            }
          }
        }
      `,
      pollInterval: 60000,
      variables() {
        return {
          page: this.currentPage,
          onlyNew: false
        };
      }
    }
  },
  methods: {
    elapsedTime(startTime) {
      const x = new Date(startTime);
      const now = new Date();
      let timeDiff = now - x;
      timeDiff /= 1000;

      const seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      const minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      const hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      const days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      const years = timeDiff;

      if (years > 0) {
        return `vor ${years + (years > 1 ? " Jahren " : " Jahr ")}`;
      } else if (days > 0) {
        return `vor ${days + (days > 1 ? " Tagen " : " Tag ")}`;
      } else if (hours > 0) {
        return `vor ${hours + (hours > 1 ? " Stunden " : " Stunde ")}`;
      } else if (minutes > 0) {
        return `vor ${minutes + (minutes > 1 ? " Minuten " : " Minute ")}`;
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " Sek. zuvor" : "gerade eben");
      }

      return "gerade eben";
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      const date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
    markRead(id, data) {
      if (data) {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {};
        }
      }
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              notificationMarkRead(id: $id)
            }
          `,
          variables: {
            id: id
          }
        })
        .then(() => {
          this.$apollo.queries.notifications.refetch();
          if (data.ref_type == "APPLICANT" && data.ref_id) {
            this.$router.push({
              name: "applicant.edit",
              params: { id: data.ref_id }
            });
          }
          if (data.ref_type == "COMPANY" && data.ref_id) {
            this.$router.push({
              name: "company.edit",
              params: { id: data.ref_id }
            });
          }
          if (data.vacancy_id && data.vacancy_project_id) {
            this.$router.push({
              name: "project.edit.sub.job",
              params: {
                id: data.vacancy_project_id,
                page: "jobs",
                jobid: data.vacancy_id
              }
            });
          }
        });
    },
    deleteNtf(id) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              notificationDelete(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: id
          }
        })
        .then(() => {
          this.$apollo.queries.notifications.refetch();
        });
    }
  }
};
</script>
